import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { MarineApiService } from 'src/app/core/services/api/marine-api.service';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { Owner } from '../../models/data/owner';


@Component({
  selector: 'app-owner-create-edit',
  templateUrl: './owner-create-edit.component.html',
  styleUrls: ['./owner-create-edit.component.scss']
})
export class OwnerCreateEditComponent implements OnInit {
  public owner: Owner;
  public cities = cities;
  public countries = countries;

  @ViewChild('ownerModal') ownerModal;
  @Output() submit: EventEmitter<Owner> = new EventEmitter<Owner>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private api: MarineApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(owner: Owner) {
    this.owner = Object.assign(new Owner(), owner);
    this.modalRef = this.modalService.open(this.ownerModal, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }

  close() {
    this.closeModal.emit();
    this.modalRef.close();
  }

  onSubmit() {
    if (this.owner.id) {
      this.spinner.show();
      this.api.updateOwner(this.owner).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
          this.closeModal.emit();
        }
      )
    } else {
      this.spinner.show();
      this.api.createOwner(this.owner).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
          this.closeModal.emit();
        }
      )
    }
  }

}

